import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Paper,
    CircularProgress,
    Pagination,
    PaginationItem,
    Button,
    Chip,
    Collapse,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { getalltaskids, getreportdata, getreportdetails } from "../api";
import { getToken } from "../../../utils/utils";
import { useDebounce } from "use-debounce";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { KeyboardArrowRight } from "@mui/icons-material";
import arrowleft from "../../../../src/assests/images/arrow_left.svg";
import tagcancel from "../../../../src/assests/images/close.svg";
import SortingArrow from "../../../../src/assests/images/Sorting.svg";
import DropDownFilter, { Option } from "../RetailerAll/DropDownFilter";

interface ReportData {
    user_id: string;
    retailer_name: string;
    outlet_name: string;
    locations: string;
    pmi_entity_code: string;
    outlet_type: string;
    ongoingtskcount: string;
    total_points: string;
    member_since: string;
    phone_no: string;
    Current_points: string;
    Tasks_given: string;
    Total_lifetime_points: string;
    Total_redeemed_points: string;
    Last_redemption_date: string;
    Tasks_completed: string;
    Current_active_tasks: string;
    Current_active_tasks_completed: string;
    last_login: string;
}

function createData(
    user_id: string,
    retailer_name: string,
    outlet_name: string,
    locations: string,
    pmi_entity_code: string,
    outlet_type: string,
    ongoingtskcount: string,
    total_points: string
): ReportData {
    return {
        user_id,
        retailer_name,
        outlet_name,
        locations,
        pmi_entity_code,
        outlet_type,
        ongoingtskcount,
        total_points,
        member_since: "",
        phone_no: "",
        Current_points: "",
        Tasks_given: "",
        Total_lifetime_points: "",
        Total_redeemed_points: "",
        Last_redemption_date: "",
        Tasks_completed: "",
        Current_active_tasks: "",
        Current_active_tasks_completed: "",
        last_login: "",
    };
}

function Row(props: {
    row: ReportData;
    taskDetails222: any;
    alldata: any;
    appliedFilters: Record<string, string[]>;
    startDate1?: string | null;
    endDate1?: string | null;
    idid: Record<string, (string | null)[]>;
    visibleColumns: string[];
}) {
    const { row, taskDetails222, alldata, appliedFilters, startDate1, endDate1, idid, visibleColumns } = props;
    const columnKeyMap: Record<string, keyof ReportData | string> = {
        "User ID": "user_id",
        "PMI Entity Code": "pmi_entity_code",
        "Retailer Name": "retailer_name",
        "Outlet Name": "outlet_name",
        "Locations": "locations",
        "Outlet Type": "outlet_type",
        "Ongoing Task": "ongoingtskcount",
        "Total Points": "total_points",
        "Member Since": "member_since",
        "Phone Number": "phone_no",
        "Current Points": "Current_points",
        "Tasks Given": "Tasks_given",
        "Total Lifetime Points": "Total_lifetime_points",
        "Total Redeemed Points": "Total_redeemed_points",
        "Last Redemption Date": "Last_redemption_date",
        "Tasks Completed": "Tasks_completed",
        "Current Active Tasks": "Current_active_tasks",
        "Current Active Tasks Completed": "Current_active_tasks_completed",
        "Last Login Date": "last_login",
    };

    console.log(alldata, "alldataalldataalldataalldata");
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = useState(true);

    interface TaskDetails {
        task_name: string;
        task_type: string;
        assigned_task: string;
        status: string;
        durations: string;
        submitted_on: string;
        reassign_count: string;
        completions_count: string;
    }
    const [taskstatus1, settaskstatus] = useState<any[]>([]);
    const [tasktype1, settaskname] = useState<any[]>([]);
    const [taskDetails, setTaskDetails] = useState<TaskDetails[]>([]);
    const [taskDetails2, setTaskDetails2] = useState([]);
    const [retailernumber, setRetailernumber] = useState<string>("");
    const [taskname1, settaskname1] = useState<string>("");
    const [tasktypess, settasktype1] = useState<string>("");
    const [taskmainstatus, settaskmainstatus] = useState<string>("");

    const location = useLocation();
    const navigate = useNavigate();

    const allValues = Object.values(appliedFilters)
        .flat()
        .filter(Boolean)
        .join(",");

    console.log(allValues, "allFilterseaadsjdw7777777777");

    useEffect(() => {
        if (location.state?.taskstatus) {
            settaskstatus(location.state.taskstatus);
        }
    }, [location.state]);

    const [taskstartDate, settaskstartDate] = useState("");
    const [taskendDate, settaskendDate] = useState("");

    useEffect(() => {
        if (location.state?.startDate) {
            console.log(location.state?.startDate, location.state?.endDate, "oooooooooooooooo");

            const formatDate = (dateString: any) => {
                if (!dateString) return "";
                const date = new Date(dateString);
                return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
            };

            settaskstartDate(formatDate(location.state?.startDate));
            settaskendDate(formatDate(location.state?.endDate));

            setTimeout(() => {
                settaskstartDate("");
                settaskendDate("");
            }, 2000);
        }
    }, [location.state]);

    console.log(taskendDate, taskstartDate, "ddddddddddddddddddddddd");

    useEffect(() => {
        if (location.state?.selectedtaskstypeeeFilters) {
            settasktype1(location.state.selectedtaskstypeeeFilters);
        }
    }, [location.state]);

    useEffect(() => {
        if (location.state?.taskname) {
            settaskname(location.state.taskname);
        }
    }, [location.state]);

    useEffect(() => {
        if (location.state?.selectedtasksnamesFilters) {
            settaskname1(location.state.selectedtasksnamesFilters);
        }
    }, [location.state]);

    useEffect(() => {
        if (location.state?.selectedSelectedmainstatus) {
            settaskmainstatus(location.state.selectedSelectedmainstatus);
        }
    }, [location.state]);

    console.log(taskname1, "uuuuuuuuuu");

    useEffect(() => {
        const retailerFilteredData = taskDetails222.filter((item: { retailerIds: any }) => {
            const retailerIdsArray = Array.isArray(item.retailerIds)
                ? item.retailerIds.map((id) => String(id).trim())
                : String(item.retailerIds)
                    .split(",")
                    .map((id) => id.trim());
            const hasMatch = alldata.some((ee: { user_id: any }) => {
                return retailerIdsArray.includes(String(ee.user_id));
            });
            return hasMatch;
        });

        if (retailerFilteredData.length > 0) {
            navigate(`/reports/taskreports`, {
                state: { filteredDatafinalforlocations: retailerFilteredData },
            });
        }
    }, [taskDetails222, alldata, navigate]);

    const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
    console.log(idid, "idid444444444444333333333");
    console.log(tasktypess, "tasktypess333333333");
    console.log(taskmainstatus, "taskmainstatustaskmainstatus");
    console.log(taskstartDate, taskendDate, "dsssswwwqqqqqqqqqqqq");
    console.log(appliedFilters, "fdfappliedFiltersappliedFilterss");

    const TaskTypes = Array.isArray(appliedFilters.TaskType) && appliedFilters.TaskType.length > 0
        ? appliedFilters.TaskType.join(",")
        : "";

    const Taskids = Array.isArray(idid.Tasks) && idid.Tasks.length > 0
        ? idid.Tasks.join(",")
        : "";

    const TaskStatus = Array.isArray(appliedFilters.Status) && appliedFilters.Status.length > 0
        ? appliedFilters.Status.join(",")
        : "";

    const Tasknames1 = Array.isArray(appliedFilters.Tasks) && appliedFilters.Tasks.length > 0
        ? appliedFilters.Tasks.join(",")
        : "";
    console.log(startDate1, endDate1, "startDate1startDate1startDate1startDate1");

    const fetchTaskDetails = async (user_id: string) => {
        const token = getToken();
        console.log(user_id, "Fetching details for user_id");

        const reqBody = {
            retailer_id: user_id,
            task_type: Array.isArray(appliedFilters.TaskType) ? appliedFilters.TaskType : [],
            task_status: Array.isArray(appliedFilters.Status) ? appliedFilters.Status : [],
            task_name: Taskids,
            task_start_date: startDate1 ?? null,
            task_end_date: endDate1 ?? null,
        };

        try {
            setIsLoading(true);
            const response = await getreportdetails(reqBody, token);
            setTaskDetails(response?.data?.data || []);
        } catch (error) {
            console.error("Error fetching task details:", error);
            setTaskDetails([]);
        } finally {
            setIsLoading(false);
        }
    };

    const [sortConfig, setSortConfig] = useState<{
        key: string;
        direction: "asc" | "desc";
    }>({
        key: "task_name",
        direction: "asc",
    });

    const sortRows = (key: string) => {
        const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";

        setSortConfig({ key, direction });

        const getComparableValue = (val: any) => {
            if (val == null) return "";
            if (typeof val === "string") return val.toLowerCase();
            if (typeof val === "number") return val;
            if (val instanceof Date) return val.getTime();
            return String(val).toLowerCase();
        };

        const sortedRows = [...taskDetails].sort((a, b) => {
            const aValue = getComparableValue(a[key as keyof TaskDetails]);
            const bValue = getComparableValue(b[key as keyof TaskDetails]);

            if (aValue < bValue) return direction === "asc" ? -1 : 1;
            if (aValue > bValue) return direction === "asc" ? 1 : -1;
            return 0;
        });

        setTaskDetails(sortedRows);
    };

    const renderSortArrow = (key: string) => {
        const isActive = sortConfig.key === key;
        const isDescending = isActive && sortConfig.direction === "desc";

        return (
            <ArrowDownwardIcon
                fontSize="small"
                sx={{
                    transition: "transform 0.2s ease-in-out",
                    transform: isDescending ? "rotate(180deg)" : "rotate(0deg)",
                    ml: 0.5,
                    opacity: isActive ? 1 : 1,
                }}
            />
        );
    };

    const handleIconClick = (user_id: string) => {
        console.log("Selected user_id:", user_id);

        setOpen((prevOpen) => {
            const newState = !prevOpen;
            if (!prevOpen) {
                setSelectedUserId(user_id);
                fetchTaskDetails(user_id);
            }
            return newState;
        });
    };

    useEffect(() => {
        console.log("Inside useEffect", selectedUserId, Taskids, TaskTypes, TaskStatus, startDate1, endDate1);

        if (selectedUserId && (Taskids || TaskTypes || TaskStatus || startDate1 || endDate1)) {
            fetchTaskDetails(selectedUserId);
        }
    }, [selectedUserId, Taskids, TaskTypes, TaskStatus, startDate1, endDate1]);

    return (
        <React.Fragment>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                {visibleColumns.map((col, index) => (
                    <TableCell key={col} sx={{ width: `${100 / visibleColumns.length}%` }} component={index === 0 ? "th" : undefined} scope={index === 0 ? "row" : undefined}>
                        {index === 0 && (
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => handleIconClick(row.user_id)}
                                sx={{ cursor: "pointer !important" }}
                            >
                                {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRight />}
                            </IconButton>
                        )}
                        {col === "Total Points" ? row.total_points : row[columnKeyMap[col] as keyof ReportData] || "-"}
                    </TableCell>
                ))}
            </TableRow>
            <TableRow style={{ width: "100%" }}>
                <TableCell style={{ padding: 0, width: "100%" }} colSpan={visibleColumns.length}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 0, width: "100%" }}>
                            <Table aria-label="purchases" size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#F1F3FB" }}>
                                        <TableCell onClick={() => sortRows("task_name")} sx={{ width: "12.5%" }} align="left">
                                            <Typography sx={{ display: "flex", alignItems: "center", cursor: "pointer !important" }}>
                                                Task Name {renderSortArrow("task_name")}
                                            </Typography>
                                        </TableCell>
                                        <TableCell onClick={() => sortRows("task_type")} sx={{ width: "12.5%" }} align="left">
                                            <Typography sx={{ display: "flex", alignItems: "center", cursor: "pointer !important" }}>
                                                Task Type {renderSortArrow("task_type")}
                                            </Typography>
                                        </TableCell>
                                        <TableCell onClick={() => sortRows("reassign_count")} sx={{ width: "12.5%" }} align="left">
                                            <Typography sx={{ display: "flex", alignItems: "center", cursor: "pointer !important" }}>
                                                Reassign Count {renderSortArrow("reassign_count")}
                                            </Typography>
                                        </TableCell>
                                        <TableCell onClick={() => sortRows("assigned_task")} sx={{ width: "12.5%" }} align="left">
                                            <Typography sx={{ display: "flex", alignItems: "center", cursor: "pointer !important" }}>
                                                Assigned Date {renderSortArrow("assigned_task")}
                                            </Typography>
                                        </TableCell>
                                        <TableCell onClick={() => sortRows("status")} sx={{ width: "12.5%" }} align="left">
                                            <Typography sx={{ display: "flex", alignItems: "center", cursor: "pointer !important" }}>
                                                Status {renderSortArrow("status")}
                                            </Typography>
                                        </TableCell>
                                        <TableCell onClick={() => sortRows("durations")} sx={{ width: "12.5%" }} align="left">
                                            <Typography sx={{ display: "flex", alignItems: "center", cursor: "pointer !important" }}>
                                                Durations {renderSortArrow("durations")}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ width: "12.5%" }} align="left">
                                            <Typography sx={{ display: "flex", alignItems: "center", cursor: "pointer !important" }}>
                                                Completion Time
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ width: "12.5%" }} align="left">
                                            <Typography sx={{ display: "flex", alignItems: "center", cursor: "pointer !important" }}>
                                                Submitted On
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {taskDetails.map((historyRow, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row">{historyRow.task_name}</TableCell>
                                            <TableCell align="left">{historyRow.task_type}</TableCell>
                                            <TableCell align="left">{historyRow.reassign_count}</TableCell>
                                            <TableCell align="left">{historyRow.assigned_task}</TableCell>
                                            <TableCell align="left">
                                                <Typography variant="body1" sx={{ fontSize: "14px", background: "#f7f7f7", borderRadius: "10px", display: "inline-block", padding: "5px 10px" }}>
                                                    {historyRow.status}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="left">{historyRow.durations}</TableCell>
                                            <TableCell align="left">
                                                <Typography variant="body1" sx={{ fontSize: "14px", color: "#F38305" }}>
                                                    {historyRow.completions_count}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="left">{historyRow.submitted_on}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

type CollapsibleTableProps = {
    searchQuery: string;
    taskDetails: Array<{ value: number; name: string }>;
    appliedFilters: Record<string, string[]>;
    setAppliedFilters: Dispatch<SetStateAction<Record<string, string[]>>>;
    dateRange: string;
    startDate1?: string | null;
    endDate1?: string | null;
    idid: Record<string, (string | null)[]>;
    tags: string[];
    setTags: React.Dispatch<React.SetStateAction<string[]>>;
    selectedRange: string;
    selectedTab: number;
    applydetailes: boolean;
};

export default function ReportTrTable({
    searchQuery,
    taskDetails,
    applydetailes,
    appliedFilters,
    dateRange,
    startDate1,
    endDate1,
    idid,
    tags,
    setTags,
    setAppliedFilters,
    selectedRange,
    selectedTab,
}: CollapsibleTableProps) {
    const navigate = useNavigate();
    const location = useLocation();
    console.log(dateRange[0], "dateRangedateRange");
    const { tasklocations } = location.state || {};
    console.log(startDate1, endDate1, "fuhfireuuuuuuuuuuuuuuuuuuuu");

    interface ReportData {
        index: string;
        id: string;
        user_id: string;
        retailer_name: string;
        outlet_name: string;
        locations: string;
        pmi_entity_code: string;
        outlet_type: string;
        ongoingtskcount: string;
        total_points: string;
        member_since: string;
        phone_no: string;
        Current_points: string;
        Tasks_given: string;
        Total_lifetime_points: string;
        Total_redeemed_points: string;
        Last_redemption_date: string;
        Tasks_completed: string;
        Current_active_tasks: string;
        Current_active_tasks_completed: string;
        last_login: string;
    }

    const [filteredRows, setRows] = useState<ReportData[]>([]);
    const [totallocationsdata, settotallocationsdata] = useState<ReportData[]>([]);
    console.log(totallocationsdata, "totallocationsdatatotallocationsdata");
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState("10");
    const [isLoading, setIsLoading] = useState(true);
    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
    const [totalcount, settotalcount] = useState(0);
    const [totalcountlocations, settotallocations] = useState(0);
    console.log(appliedFilters.Location, "appliedFiltersssssssssswwwwwwwqqqqqqqq");
    const aplliesfilterslocations = Array.isArray(appliedFilters.Location) && appliedFilters.Location.length > 0
        ? appliedFilters.Location.join(",")
        : "";
    console.log(aplliesfilterslocations, "aplliesfilterslocations");

    const allColumns = [
        "User ID",
        "PMI Entity Code",
        "Retailer Name",
        "Outlet Name",
        "Locations",
        "Member Since",
        "Outlet Type",
        "Phone Number",
        "Current Points",
        "Tasks Given",
        "Total Lifetime Points",
        "Total Redeemed Points",
        "Last Redemption Date",
        "Tasks Completed",
        "Current Active Tasks",
        "Current Active Tasks Completed",
        "Last Login Date",
    ];

    const columnKeyMap: Record<string, keyof ReportData | string> = {
        "User ID": "user_id",
        "PMI Entity Code": "pmi_entity_code",
        "Retailer Name": "retailer_name",
        "Outlet Name": "outlet_name",
        "Locations": "locations",
        "Member Since": "member_since",
        "Outlet Type": "outlet_type",
        "Phone Number": "phone_no",
        "Current Points": "Current_points",
        "Tasks Given": "Tasks_given",
        "Total Lifetime Points": "Total_lifetime_points",
        "Total Redeemed Points": "Total_redeemed_points",
        "Last Redemption Date": "Last_redemption_date",
        "Tasks Completed": "Tasks_completed",
        "Current Active Tasks": "Current_active_tasks",
        "Current Active Tasks Completed": "Current_active_tasks_completed",
        "Last Login Date": "last_login",
    };

    const [visibleColumns, setVisibleColumns] = useState<string[]>(allColumns.slice(0, 6));

    // Map allColumns to DropDownFilter Option format
    const columnOptions: Option[] = allColumns.map((col) => ({
        label: col,
        value: col,
    }));

    const [sortConfig, setSortConfig] = useState<{
        key: string;
        direction: "asc" | "desc";
    }>({
        key: "user_id",
        direction: "asc",
    });

    const handleSort = (key: string) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
        }));
    };

    const token = getToken();

    const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const sortRows = (key: string) => {
        const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";

        setSortConfig({ key, direction });

        const getComparableValue = (val: any) => {
            if (val == null) return "";
            if (typeof val === "string") return val.toLowerCase();
            if (typeof val === "number") return val;
            if (val instanceof Date) return val.getTime();
            return String(val).toLowerCase();
        };

        const sortedRows = [...filteredRows].sort((a, b) => {
            const aValue = getComparableValue(a[key as keyof typeof a]);
            const bValue = getComparableValue(b[key as keyof typeof b]);

            if (aValue < bValue) return direction === "asc" ? -1 : 1;
            if (aValue > bValue) return direction === "asc" ? 1 : -1;
            return 0;
        });

        setRows(sortedRows);
    };

    const renderSortArrow = (key: string) => {
        const isActive = sortConfig.key === key;
        const isDescending = isActive && sortConfig.direction === "desc";

        return (
            <ArrowDownwardIcon
                fontSize="small"
                sx={{
                    transition: "transform 0.2s ease-in-out",
                    transform: isDescending ? "rotate(180deg)" : "rotate(0deg)",
                    ml: 0.5,
                    opacity: isActive ? 1 : 1,
                }}
            />
        );
    };

    const perpagedata = 10;
    const [debouncedSearchTerm] = useDebounce(searchQuery, 500);

    useEffect(() => { }, [tasklocations]);

    const [currentTaskLocations, setCurrentTaskLocations] = useState<string[]>([]);

    useEffect(() => { }, [currentTaskLocations]);

    useEffect(() => {
        setCurrentTaskLocations(tasklocations || []);
    }, [tasklocations]);

    console.log(searchQuery, "searchQuerysearchQuerysearchQuerysearchQuery");
    const [selecteddatrange, setselecteddaterange] = useState<string>("");
    useEffect(() => {
        if (location.state?.selecteddateRangedateRange) {
            console.log(location.state?.selecteddateRangedateRange, "location.state?.selecteddatrangeeeee");
            setselecteddaterange(location.state.selecteddateRangedateRange);
        }
    }, [location.state]);
    console.log(selecteddatrange[0], "selecteddatrange4444444444444");

    const [taskmainlocations, settaskmainlocations] = useState<string>("");
    useEffect(() => {
        if (location.state?.selectedtaskmainlocations) {
            settaskmainlocations(location.state.selectedtaskmainlocations);
        }
    }, [location.state]);

    console.log(appliedFilters, "appliedFilters885555555");
    const Taskids = Array.isArray(idid?.Tasks) && idid.Tasks.length > 0 ? idid.Tasks.join(",") : "";
    const TaskTypes = Array.isArray(appliedFilters?.TaskType) && appliedFilters.TaskType.length > 0 ? appliedFilters.TaskType.join(",") : "";
    const Reassign_count = Array.isArray(appliedFilters?.ReassignCount) && appliedFilters.ReassignCount.length > 0 ? appliedFilters.ReassignCount.join(",") : "";
    const lastlogin = Array.isArray(appliedFilters?.LastLogin) ? appliedFilters.LastLogin.join(",") : "";
    const TaskStatus = Array.isArray(appliedFilters?.Status) && appliedFilters.Status.length > 0 ? appliedFilters.Status.join(",") : "";

    console.log(lastlogin, "lastloginssssssssssss");
    console.log(selectedRange, "selectedRangeselectedRange");
    console.log(applydetailes, "applydetailesssssssssss");

    const handleColumnSelect = (selected: string[]) => {
        setVisibleColumns(selected);
    };

    const fetchData = async () => {
        setIsLoading(true);

        const formatDate = (date: string) => new Date(date).toDateString();

        const reqBody = {
            locations: aplliesfilterslocations,
            search: debouncedSearchTerm,
            lastLogin: selectedTab === 5 && applydetailes ? selectedRange : "",
            TaskTypes: Array.isArray(appliedFilters.TaskType) ? appliedFilters.TaskType : [],
            TaskStatus: Array.isArray(appliedFilters.Status) ? appliedFilters.Status : [],
            taskIds: Array.isArray(Taskids) ? Taskids : Taskids ? [Taskids] : [],
            Reassign_count: Array.isArray(Reassign_count)
                ? Reassign_count.map(Number)
                : Reassign_count
                    ? [Number(Reassign_count)]
                    : [],
            task_start_date: startDate1 ?? null,
            task_end_date: endDate1 ?? null,
            page: String(page),
            limit: rowsPerPage,
            startdate: selecteddatrange[0] ? formatDate(selecteddatrange[0]) : null,
            enddate: selecteddatrange[1] ? formatDate(selecteddatrange[1]) : null,
        };

        try {
            const response = await getreportdata(reqBody, token);

            const mappedData = response.data.data.results.map((item: any) => ({
                user_id: item.user_id,
                retailer_name: item.retailer_name,
                outlet_name: item.outlet_name,
                locations: item.locations,
                member_since: item.member_since,
                pmi_entity_code: item.pmi_entity_code,
                outlet_type: item.outlet_type,
                total_points: item.total_points,
                ongoingtskcount: item.ongoingtskcount,
                phone_no: item.phone_no || "-",
                Current_points: item.Current_points || "-",
                Tasks_given: item.Tasks_given || "-",
                Total_lifetime_points: item.Total_lifetime_points || "-",
                Total_redeemed_points: item.Total_redeemed_points || "-",
                Last_redemption_date: item.Last_redemption_date || "-",
                Current_active_tasks: item.Current_active_tasks || "-",
                Current_active_tasks_completed: item.Current_active_tasks_completed || "-",
                Tasks_completed: item.Tasks_completed || "-",
                last_login: item.last_login || "-",
            }));

            setRows(mappedData);
            settotalcount(response.data.data.Totalcount);
            if (response.data.data.locationscount !== 0) {
                settotallocationsdata(mappedData);
            }
            settotallocations(response.data.data.locationscount);
        } catch (error) {
            console.error("Error fetching data:", error);
            setRows([]);
            settotalcount(0);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [
        page,
        rowsPerPage,
        debouncedSearchTerm,
        aplliesfilterslocations,
        Taskids,
        Reassign_count,
        TaskTypes,
        TaskStatus,
        startDate1,
        endDate1,
    ]);

    useEffect(() => {
        if (selectedTab === 5 && applydetailes) {
            fetchData();
        }
    }, [selectedRange, selectedTab, applydetailes]);

    const totalPages = Math.ceil(totalcount / perpagedata);
    console.log(totalPages, "totalPagestotalPages");

    useEffect(() => {
        if (filteredRows.length > 0) {
            navigate(`/reports/taskreports`, { state: { data: filteredRows } });
        }
    }, [filteredRows]);

    const leghtdata = filteredRows.length ? filteredRows.length : "";
    const [selectedcombinedFilters22, setselectedcombinedFilters] = useState<string>("");

    useEffect(() => {
        if (location.state?.selectedcombinedFilters) {
            setselectedcombinedFilters(location.state.selectedcombinedFilters);
        }
    }, [location.state]);

    console.log(selectedcombinedFilters22, "selectedcombinedFilters22selectedcombinedFilters22");

    useEffect(() => {
        const newTags = Object.values(appliedFilters)
            .flat()
            .filter(Boolean);
        setTags(newTags);
    }, [appliedFilters]);

    const handleRemoveTag = (tagToRemove: string) => {
        console.log("Removing tag:", tagToRemove);

        setTags((prevTags) => {
            const updatedTags = prevTags.filter((tag) => tag !== tagToRemove);
            console.log("Updated tags:", updatedTags);
            return updatedTags;
        });

        setAppliedFilters((prevFilters) => {
            const updatedFilters = Object.fromEntries(
                Object.entries(prevFilters).map(([key, values]) => [
                    key,
                    values.filter((item: any) => item !== tagToRemove),
                ])
            );
            return updatedFilters;
        });
    };

    useEffect(() => {
        console.log("Applied Filters Changed:", appliedFilters);
        setTags((prevTags) => {
            const newTags = Object.values(appliedFilters)
                .flat()
                .filter(Boolean);
            console.log("New Tags Computed:", newTags);
            return Array.from(new Set(newTags));
        });
    }, [appliedFilters]);

    console.log(totalcount, "fffffffffffffffffffff");

    return (
        <>
            <Box sx={{ width: "100%", marginTop: "-80px", display: "flex", flexDirection: "column", gap: "10px" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: "600", margin: "30px 24px" }}>
                        {`Total ${totalcount} Users`}
                    </Typography>
                    <Box sx={{ width: "300px", marginLeft: "424px" }}>
                        <DropDownFilter
                            placeholder="Select Columns"
                            options={columnOptions}
                            value={visibleColumns}
                            onChange={handleColumnSelect}
                            maxMenuHeight={350}
                            showSelectAll={true} tabKey={""}                        />
                    </Box>
                    {selectedcombinedFilters22 !== "" && (
                        <Typography sx={{ marginTop: "30px" }}>
                            {selectedcombinedFilters22.split(",").map((label, index) => (
                                <Chip
                                    key={index}
                                    label={label}
                                    sx={{
                                        backgroundColor: "#EAF5FE",
                                        color: "#0F7CAD",
                                        borderRadius: "6px",
                                        fontSize: "14px",
                                        height: "30px",
                                        cursor: "pointer",
                                        marginRight: "10px",
                                    }}
                                />
                            ))}
                        </Typography>
                    )}
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "20px 24px",
                        borderTop: "1px solid #E4E7EC",
                    }}
                >
                    <Box sx={{ fontSize: "16px", color: "#494A4B", fontWeight: "500", whiteSpace: "nowrap" }}>
                        Applied Filters :
                    </Box>
                    <Box sx={{ width: "100%", overflow: "auto", display: "flex" }}>
                        {tags.map((tag) => (
                            <Box
                                key={tag}
                                sx={{
                                    whiteSpace: "nowrap",
                                    marginRight: "10px",
                                    backgroundColor: "#EAF5FE",
                                    borderRadius: "8px",
                                    padding: "4px 16px",
                                    color: "#0F7CAD",
                                    display: "flex",
                                    gap: "8px",
                                }}
                            >
                                {tag}
                                <img
                                    style={{ cursor: "pointer", width: "15px" }}
                                    onClick={() => handleRemoveTag(tag)}
                                    src={tagcancel}
                                    alt="tagcancel"
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
            <Paper sx={{ boxShadow: "none", borderRadius: "12px" }}>
                <TableContainer>
                    <Table className="report-table" sx={{ "& .MuiTableRow-root th p": { fontSize: "14px" } }}>
                        <TableHead>
                            <TableRow sx={{ background: "#EEF4FF", borderRadius: "0" }}>
                                {visibleColumns.map((col) => (
                                    <TableCell
                                        key={col}
                                        onClick={() => sortRows(columnKeyMap[col] as string)}
                                        sx={{ borderRight: col === visibleColumns[0] ? "1px solid #E4E7EC" : undefined }}
                                    >
                                        <Typography sx={{ display: "flex", alignItems: "center", cursor: "pointer !important", fontSize: "14px" }}>
                                            {col} {renderSortArrow(columnKeyMap[col] as string)}
                                            <TableSortLabel
                                                active={sortConfig.key === columnKeyMap[col]}
                                                direction={sortConfig.direction === "asc" ? "asc" : "desc"}
                                                onClick={() => sortRows(columnKeyMap[col] as string)}
                                                IconComponent={() => (
                                                    <img
                                                        src={SortingArrow}
                                                        alt="Sort Icon"
                                                        style={{
                                                            width: 18,
                                                            height: 18,
                                                            marginLeft: 4,
                                                            transform:
                                                                sortConfig.key === columnKeyMap[col] && sortConfig.direction === "desc"
                                                                    ? "rotate(180deg)"
                                                                    : "rotate(0deg)",
                                                            transition: "transform 0.2s ease-in-out",
                                                        }}
                                                    />
                                                )}
                                                sx={{
                                                    "& .MuiTableSortLabel-icon": {
                                                        opacity: 1,
                                                    },
                                                }}
                                            />
                                        </Typography>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        {isLoading ? (
                            <Box sx={{ margin: "auto", textAlign: "center", width: "1000px" }}>
                                <CircularProgress />
                            </Box>
                        ) : (
                            <TableBody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row) => (
                                        <Row
                                            key={row.user_id || row.id || row.index}
                                            row={row}
                                            taskDetails222={taskDetails}
                                            alldata={totallocationsdata}
                                            appliedFilters={appliedFilters}
                                            startDate1={startDate1}
                                            endDate1={endDate1}
                                            idid={idid}
                                            visibleColumns={visibleColumns}
                                        />
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={visibleColumns.length} align="center">
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>

                {!isLoading && filteredRows.length > 0 ? (
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(event, value) => handleChangePage(event, value)}
                        renderItem={(item) => (
                            <PaginationItem
                                {...item}
                                slots={{
                                    previous: () => (
                                        <Button
                                            variant="contained"
                                            sx={{
                                                backgroundColor: "transparent",
                                                border: "1px solid rgba(208, 213, 221, 1)",
                                                borderRadius: "8px",
                                                boxShadow: "none",
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "#000",
                                                textTransform: "capitalize",
                                                opacity: "1",
                                                "MuiPaginationItem-root.Mui-disabled": {
                                                    opacity: "1 !important",
                                                },
                                            }}
                                        >
                                            <img style={{ marginRight: "12px" }} src={arrowleft} alt="ArrowBackIcon" />
                                            Previous
                                        </Button>
                                    ),
                                    next: () => (
                                        <Button
                                            variant="contained"
                                            sx={{
                                                backgroundColor: "transparent",
                                                border: "1px solid rgba(208, 213, 221, 1)",
                                                borderRadius: "8px",
                                                boxShadow: "none",
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "#000",
                                                textTransform: "capitalize",
                                                opacity: "1",
                                            }}
                                        >
                                            Next
                                            <img
                                                style={{ marginLeft: "12px", transform: "rotate(180deg)" }}
                                                src={arrowleft}
                                                alt="ArrowBackIcon"
                                            />
                                        </Button>
                                    ),
                                }}
                            />
                        )}
                        sx={{
                            "li:first-child": { position: "absolute", left: "10px" },
                            "li:last-child": { position: "absolute", right: "10px" },
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "20px 24px",
                            borderRadius: "12px",
                            ".Mui-selected ": {
                                backgroundColor: "rgba(245, 251, 255, 1) !important",
                                borderRadius: "8px",
                                color: "rgba(87, 163, 253, 1)",
                                fontWeight: "500",
                                ".MuiPaginationItem-text": {
                                    fontSize: "14px !important",
                                    fontWeight: "500",
                                },
                            },
                        }}
                    />
                ) : (
                    <Typography variant="h6" sx={{ textAlign: "center", color: "gray" }}>
                        No data found
                    </Typography>
                )}
            </Paper>
        </>
    );
}